import { useEffect, useMemo } from 'react'

import { getTokenCatalog } from '@sirius-cybernetics-42/product-config'

import { getActiveChainId } from '@/config/active'
import { syncTokenPolicyFromCatalog } from '@/config/marketPolicy'
import type { TokenCatalogEntry } from '@/data/marketApi/types'

/**
 * Catálogo de tokens de producto — product-config (flags / identidad).
 * Nutrimatic enriquece perfiles vía `useTokenProfile`, no sustituye este catálogo.
 */
export function useTokenCatalog() {
  const chainId = getActiveChainId()

  const entries = useMemo(() => getTokenCatalog(chainId), [chainId])

  useEffect(() => {
    syncTokenPolicyFromCatalog(chainId, entries)
  }, [chainId, entries])

  return {
    entries,
    isLoading: false,
    isFromApi: false,
  }
}

export function useTokenCatalogEntries(): TokenCatalogEntry[] {
  return useTokenCatalog().entries
}
